import type { AuthUser } from '../contexts/AuthContext';

/** Profissional vinculado ao usuário logado (JWT /auth/me), para pré-preencher evoluções e documentos. */
export function getLoggedInProfessionalOption(
  user: AuthUser | null,
): { id: string; full_name: string; specialty?: string } | null {
  if (!user?.professional_id) return null;
  const p = user.professional;
  const fullName = (p?.full_name || user.full_name || '').trim();
  if (!fullName) return null;
  return {
    id: user.professional_id,
    full_name: fullName,
    specialty: p?.specialty || '',
  };
}

/** Garante que o profissional logado apareça nas opções do Autocomplete mesmo se a busca não o retornar primeiro. */
export function mergeLoggedInProfessionalIntoOptions<T extends { id: string }>(
  rows: T[],
  user: AuthUser | null,
): T[] {
  const me = getLoggedInProfessionalOption(user);
  if (!me?.id) return rows;
  if (rows.some((r) => r.id === me.id)) return rows;
  return [{ ...me } as unknown as T, ...rows];
}
